import React from "react";
import axios from "axios";
import ReactLoading from "react-loading";
import config from "../../config";
import Footer from "./Footer";
import Header from "./Header";

const Rate_card = () => {
  const [products, setProducts] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const fetchPricingData = async () => {
      try {
        setLoading(true);
        const full_api = `${config.apiUrl}/shipment/getPricingData`;
        const response = await axios.post(full_api, {}, { headers: config.headers });

        if (response.data?.success && Array.isArray(response.data.products)) {
          setProducts(response.data.products);
        } else {
          console.warn("No products found in API response:", response.data);
          setProducts([]);
        }
      } catch (error) {
        console.error("Error fetching product pricing:", error);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPricingData();
  }, []);

  const fmtVal = (v) => {
    if (v === null || v === undefined || v === "N/A") return "N/A";
    // show integer amounts without decimals, otherwise two decimals
    const num = Number(v);
    if (Number.isNaN(num)) return "N/A";
    if (Math.floor(num) === num) return `₹${num}`;
    return `₹${num.toFixed(2)}`;
  };

  const fmtPercent = (v) => {
    if (v === null || v === undefined || v === "N/A") return "N/A";
    const num = Number(v);
    if (Number.isNaN(num)) return "N/A";
    return `${num}%`;
  };

  return (
    <div>
      <Header />
      <div className="page-wrapper pinned">
        <div className="main-container">
          <div className="app-container">
            <div className="app-body">
              <div className="container-fluid">
                <h2 className="text-danger mb-3">*All prices shown are inclusive of GST.</h2>

                {/* Loading */}
                {loading ? (
                  <div className="flex flex-col items-center justify-center py-10">
                   
                    <p className="text-gray-600 mt-3 text-lg font-medium">Loading Pricing...</p>
                  </div>
                ) : products.length === 0 ? (
                  // No product available
                  <p className="text-gray-500 text-center py-4 text-lg font-medium">No product available</p>
                ) : (
                  // Products list
                  products.map((product, productIndex) => (
                    <div
                      key={productIndex}
                      className="p-4 mb-5 bg-white shadow-md rounded-xl border border-gray-200"
                    >
                      <h3 className="text-lg font-semibold mb-3 text-gray-800">
                        {product.product_name}{" "}
                        <span className="text-sm text-gray-500">({product.mode})</span>
                      </h3>

                      <div className="overflow-x-auto">
                        <table className="min-w-full border-collapse text-sm">
                          <thead>
                            <tr className="bg-gray-100 text-gray-700 text-left">
                              <th className="p-3 border border-gray-300 sticky left-0 bg-gray-100">
                                Weight Range (KG)
                              </th>
                              {product.zones.map((zone, idx) => (
                                <th
                                  key={idx}
                                  className="p-3 border border-gray-300 text-center whitespace-nowrap"
                                >
                                  {zone.zone_name}
                                </th>
                              ))}
                            </tr>
                          </thead>

                          <tbody>
                            {product.groupedPricing.map((range, idx) => (
                              <tr
                                key={idx}
                                className={idx % 2 === 0 ? "bg-white" : "bg-gray-50"}
                              >
                                <td className="p-3 border border-gray-300 font-medium text-gray-700">
                                  {range.start_range} - {range.end_range}
                                </td>
                                {product.zones.map((zone, zIdx) => {
                                  const zonePrice = range.zone_prices.find(
                                    (zp) => zp.zone_id === zone.zone_id
                                  );
                                  return (
                                    <td
                                      key={zIdx}
                                      className="p-3 border border-gray-300 text-center"
                                    >
                                      {zonePrice ? zonePrice.price : "N/A"}
                                    </td>
                                  );
                                })}
                              </tr>
                            ))}

                            {/* Additional weight pricing row */}
                            <tr className="bg-yellow-50 font-medium">
                              <td className="p-3 border border-gray-300">
                                Additional per {product.additional_weight} KG
                              </td>
                              {product.zones.map((zone, zIdx) => {
                                const additionalPrice =
                                  product.additionalPrices.find(
                                    (ap) => ap.zone_id === zone.zone_id
                                  )?.additional_price ?? "N/A";
                                return (
                                  <td
                                    key={zIdx}
                                    className="p-3 border border-gray-300 text-center"
                                  >
                                    {additionalPrice}
                                  </td>
                                );
                              })}
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      {/* COD Commission block */}
                      <div className="mt-6 border-t pt-4 text-sm text-gray-700">
  <h4 className="font-semibold mb-3 text-base text-gray-800 flex items-center">
    💰 COD Charge (Max of % of COD Amount or Flat Amount)
  </h4>

  {product.cod_commission ? (
    <>
      <p className="text-gray-600 mb-3">
        <span className="font-medium">COD Invoice Limit:</span>{" "}
        <span className="text-gray-800 font-semibold">
          ₹{product.cod_commission.cod_invoice_limit ?? "N/A"}
        </span>
      </p>

      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-300 rounded-lg overflow-hidden text-sm">
          <thead>
            <tr className="bg-gray-100 text-gray-700 text-left">
              <th className="p-3 border-b border-gray-300">COD Amount</th>
              <th className="p-3 border-b border-gray-300 text-center">% of COD</th>
              <th className="p-3 border-b border-gray-300 text-center">Flat Amount</th>
            </tr>
          </thead>
          <tbody>
            {/* Upto Limit Row */}
            <tr className="hover:bg-gray-50">
              <td className="p-3 border-t border-gray-200 font-medium text-gray-700">
                ₹0 – ₹{product.cod_commission.cod_invoice_limit ?? "N/A"}
              </td>
              <td className="p-3 border-t border-gray-200 text-center text-blue-600 font-semibold">
                {fmtPercent(
                  product.cod_commission.upto_limit
                    ?.cod_commission_percentage_upto_limit ?? "N/A"
                )}
              </td>
              <td className="p-3 border-t border-gray-200 text-center text-green-600 font-semibold">
                {fmtVal(
                  product.cod_commission.upto_limit
                    ?.cod_commission_amount_upto_limit ?? "N/A"
                )}
              </td>
            </tr>

            {/* Above Limit Row */}
            <tr className="hover:bg-gray-50">
              <td className="p-3 border-t border-gray-200 font-medium text-gray-700">
                Above ₹{product.cod_commission.cod_invoice_limit ?? "N/A"}
              </td>
              <td className="p-3 border-t border-gray-200 text-center text-blue-600 font-semibold">
                {fmtPercent(
                  product.cod_commission.above_limit
                    ?.cod_commission_percentage_above_limit ?? "N/A"
                )}
              </td>
              <td className="p-3 border-t border-gray-200 text-center text-green-600 font-semibold">
                {fmtVal(
                  product.cod_commission.above_limit
                    ?.cod_commission_amount_above_limit ?? "N/A"
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  ) : (
    <p className="text-gray-600 italic">
      COD commission not configured for this product.
    </p>
  )}
</div>

                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Rate_card;
